import { MutationTree } from 'vuex';

import {
  CalendarStateI,
  CalendarI,
  saveHiddenCalendarIds,
} from './state';

function isSameCalendarId(
  left: number | string,
  right: number | string,
) {
  return String(left) === String(right);
}

export const mutations: MutationTree<CalendarStateI> = {
  setCalendar(state: CalendarStateI, payload: CalendarI) {
    state.calendar = payload;
  },
  setCalendars(state: CalendarStateI, payload: CalendarI[]) {
    state.calendars = payload;
    state.hiddenCalendarIds = state.hiddenCalendarIds.filter((hiddenId) => (
      payload.some((calendar) => isSameCalendarId(calendar.id, hiddenId))
    ));
    saveHiddenCalendarIds(state.hiddenCalendarIds);
  },
  addCalendar(state: CalendarStateI, payload: CalendarI) {
    console.log('[mutations/addCalendar] state.calendars before:', JSON.stringify(state.calendars));
    console.log('[mutations/addCalendar] payload:', JSON.stringify(payload));
    const index = state.calendars.findIndex((calendar) => (
      isSameCalendarId(calendar.id, payload.id)
    ));
    console.log('[mutations/addCalendar] findIndex:', index);

    if (index === -1) {
      state.calendars.push(payload);
    } else {
      state.calendars.splice(index, 1, payload);
    }

    console.log('[mutations/addCalendar] state.calendars after:', JSON.stringify(state.calendars));

    state.hiddenCalendarIds = state.hiddenCalendarIds.filter((hiddenId) => (
      !isSameCalendarId(hiddenId, payload.id)
    ));
  },
  toggleCalendarVisibility(
    state: CalendarStateI,
    calendarId: number | string,
  ) {
    const isHidden = state.hiddenCalendarIds.some((hiddenId) => (
      isSameCalendarId(hiddenId, calendarId)
    ));

    if (isHidden) {
      state.hiddenCalendarIds = state.hiddenCalendarIds.filter((hiddenId) => (
        !isSameCalendarId(hiddenId, calendarId)
      ));
    } else {
      state.hiddenCalendarIds.push(calendarId);
    }

    saveHiddenCalendarIds(state.hiddenCalendarIds);
  },
  removeCalendar(state: CalendarStateI, calendarId: number | string) {
    state.calendars = state.calendars.filter((calendar) => (
      !isSameCalendarId(calendar.id, calendarId)
    ));
    state.hiddenCalendarIds = state.hiddenCalendarIds.filter((hiddenId) => (
      !isSameCalendarId(hiddenId, calendarId)
    ));
    saveHiddenCalendarIds(state.hiddenCalendarIds);
  },
  setCalendarVisibility(
    state: CalendarStateI,
    payload: { calendarId: number | string; visible: boolean },
  ) {
    const isHidden = state.hiddenCalendarIds.some((hiddenId) => (
      isSameCalendarId(hiddenId, payload.calendarId)
    ));

    if (payload.visible && isHidden) {
      state.hiddenCalendarIds = state.hiddenCalendarIds.filter((hiddenId) => (
        !isSameCalendarId(hiddenId, payload.calendarId)
      ));
    }

    if (!payload.visible && !isHidden) {
      state.hiddenCalendarIds.push(payload.calendarId);
    }

    saveHiddenCalendarIds(state.hiddenCalendarIds);
  },
};
